import React from 'react'
import './styles.scss'
import Deva from '../../assets/founders/deva.jpg'
import Gowtham from '../../assets/founders/gowtham.jpg'
import Avatar from '../../assets/founders/avatar.svg'
import { Container, Image } from 'react-bootstrap'
import { FaWhatsapp, FaInstagram, FaTwitter, FaFacebook } from 'react-icons/fa'


function Team() {
    return (
        <div className='team' id="Team">
            <h1>Team Members</h1>
            <Container className="cont">
                <div className="profile-card">
                    <Image src={Deva} fluid className="Img" />
                    <div className="details-div">
                        <p className="Name">DevaRaju <br />
                            <span className="Email">mdevaraju764@gmail.com</span>
                        </p>
                        <h6>Founder</h6>
                        <div className="follow">
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/deva.don_/"><FaInstagram /></a>
                            <a target="_blank" rel="noreferrer" href="https://twitter.com/RajuBhai170725/"><FaTwitter /></a>
                            <a  href="https://wa.me/+917997440602/?text=Hello Deva" target="_blank" rel="noreferrer" ><FaWhatsapp /></a>
                        </div>
                    </div>
                </div>
                <div className="profile-card">
                    <Image src={Avatar} fluid className="Img" />
                    <div className="details-div">
                        <p className="Name">Tarun <br />
                            <span className="Email">vegitarun1234@gmail.com</span>
                        </p>
                        <h6>Co-Founder</h6>
                        <div className="follow">
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/tarun_vei3/"><FaInstagram /></a>
                            <a target="_blank" rel="noreferrer" href="https://www.twitter.com/Tarun_vegi3/"><FaTwitter /></a>
                            <a href="https://wa.me/+916300145448/?text=Hello Tarun" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
                        </div>
                    </div>
                </div>
                <div className="profile-card">
                    <Image src={Gowtham} fluid className="Img" />
                    <div className="details-div">
                        <p className="Name">Gowtham <br />
                            <span className="Email">vickygowtham106@gmail.com</span>
                        </p>
                        <h6>Co-Founder</h6>
                        <div className="follow">
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/vicky_gowtham666/"><FaInstagram /></a>
                            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/vicky.gowtham.35"><FaFacebook /></a>
                            <a href="https://wa.me/+919618619927/?text=Hello Gowtham" target="_blank" rel="noreferrer" ><FaWhatsapp /></a>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Team
